import React from 'react';
import { useThree } from '@react-three/fiber';
import { GridHelper } from 'three';

const GridLines = ({ size = 10, divisions = 10, color1 = 'gray', color2 = 'gray' }) => {
    const { scene } = useThree();

    React.useEffect(() => {
        const gridHelper = new GridHelper(size, divisions, color1, color2);
        scene.add(gridHelper);

        return () => {
            scene.remove(gridHelper);
        };
    }, [scene, size, divisions, color1, color2]);

    return null;
};

export default GridLines;
